module.exports = __webpack_public_path__ + "static/media/AvenirLTStd-Book.287adfd5.woff";